import { render, staticRenderFns } from "./PageVmCorrection.vue?vue&type=template&id=0cd44445&"
import script from "./PageVmCorrection.vue?vue&type=script&lang=js&"
export * from "./PageVmCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports